import { Box } from "arkh";
import React from "react";
import { PILL_INDICATOR_SIZE } from "../../PillIndicator";

export function WorkspaceRoutineTemplateCreatedRoutinesItemRowContainer(props: {
  title: React.ReactNode;
  status: React.ReactNode;
  numOfRoutines: React.ReactNode;
}) {
  return (
    <Box style={{ flexDirection: "row", alignItems: "center" }}>
      <Box
        style={{ flex: 1, flexDirection: "row", alignItems: "center" }}
        spaceRight="medium"
      >
        {props.title}
      </Box>
      <Box style={{ width: 150 }}>{props.numOfRoutines}</Box>
      <Box style={{
        width: PILL_INDICATOR_SIZE.width,
        alignItems: "flex-end"
      }}>
        {props.status}
      </Box>
    </Box>
  );
}
